import {Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

export interface ConfirmationConfig {
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    confirmButtonClass?: string;
    icon?: string;
    iconClass?: string;
}

@Component({
    selector: 'app-confirmation-modal',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="modal-header border-0">
            <h5 class="modal-title d-flex align-items-center gap-2">
                @if (config.icon) {
                    <i [class]="'ti ' + config.icon + ' ' + (config.iconClass || '')"></i>
                }
                {{ config.title }}
            </h5>
            <button type="button" class="btn-close" (click)="cancel()"></button>
        </div>

        <div class="modal-body">
            <p class="mb-0" [innerHTML]="config.message"></p>
        </div>

        <div class="modal-footer border-0">
            <button type="button" class="btn btn-light" (click)="cancel()">
                {{ config.cancelText || 'Cancelar' }}
            </button>
            <button type="button" 
                    [class]="'btn ' + (config.confirmButtonClass || 'btn-danger')"
                    (click)="confirm()">
                {{ config.confirmText || 'Confirmar' }}
            </button>
        </div>
    `,
    styles: [`
        .modal-body p {
            white-space: pre-line;
        }
    `]
})
export class ConfirmationModalComponent {
    protected activeModal = inject(NgbActiveModal);

    // Use regular property instead of input signal to allow assignment from parent
    config: ConfirmationConfig = {
        title: '',
        message: ''
    };

    protected confirm(): void {
        this.activeModal.close(true);
    }

    protected cancel(): void {
        this.activeModal.close(false);
    }
}
